// Helper function to display the correct input field depending on the country type
// If the country is Hungary (Magyarország), then the zipcode and town are validated (and auto completed)
// For every other country, they are unvalidated free text

import * as AutoComplete from './_autocomplete';

export function OnCountryChanged(event: JQuery.ChangeEvent) {
    if (event !== undefined) {
        let form: JQuery<HTMLElement> = $(event.target).closest('table.form');

        let zipCodeInput: JQuery<HTMLElement> = form.find('input.zip-code');
        let orszagInput: JQuery<HTMLElement> = form.find('input.country-id');
        let magyarTelepulesNevInput: JQuery<HTMLElement> = form.find('input.settlement-name');
        let kulfoldiTelepulesNevInput: JQuery<HTMLElement> = form.find('input.foreign-settlement');

        let magyarTelepulesRow: JQuery<HTMLElement> = magyarTelepulesNevInput.closest('.magyarTelepulesRow');
        let kulfoldiTelepulesRow: JQuery<HTMLElement> = kulfoldiTelepulesNevInput.closest('.kulfoldiTelepulesRow');

        var orszag: number = orszagInput.val() as number;

        if (orszag) {
            if (orszag == 1) {
                magyarTelepulesRow.show();
                magyarTelepulesNevInput.prop('readonly', true);
                kulfoldiTelepulesRow.hide();

                zipCodeInput.attr("maxLength", 4);
            } else {
                magyarTelepulesRow.hide();
                kulfoldiTelepulesRow.show();

                zipCodeInput.attr("maxLength", 99);
            }
        }
    }
}

export function InitSettlementInputRow() {
    let orszagInputs: JQuery<HTMLElement> = $('input.country-id');

    if (orszagInputs.length > 0) {
        orszagInputs.each((i, e) => {
            var orszagId: number = $(e).val() as number;
            let magyarTelepulesRow: JQuery<HTMLElement> = $(e).closest('table.form').find('.magyarTelepulesRow');
            let kulfoldiTelepulesRow: JQuery<HTMLElement> = $(e).closest('table.form').find('.kulfoldiTelepulesRow');
            let zipCodeInput: JQuery<HTMLElement> = $(e).closest('table.form').find('input.zip-code');

            if (orszagId == null || orszagId == undefined || orszagId == 1) {
                magyarTelepulesRow.show();
                kulfoldiTelepulesRow.hide();

                zipCodeInput.attr('maxLength', 4);
            } else {
                magyarTelepulesRow.hide();
                kulfoldiTelepulesRow.show();

                zipCodeInput.attr('maxLength', 99);
            }
        });
    }
    else {
        let magyarTelepulesRow: JQuery<HTMLElement> = $('.magyarTelepulesRow');
        let kulfoldiTelepulesRow: JQuery<HTMLElement> = $('.kulfoldiTelepulesRow');
        let zipCode: JQuery<HTMLElement> = $('.zip-code');

        magyarTelepulesRow.show();
        kulfoldiTelepulesRow.hide();
        zipCode.attr('maxLength', 4);
    }
}

let postAddressDiv;
export function ToggleContactTypeFields(contactType: JQuery<HTMLElement>) {
    let $postAddressDiv: JQuery<HTMLElement> = $('#postAddressDiv');
    if (!postAddressDiv) {
        postAddressDiv = $postAddressDiv;
    }

    if (contactType.length > 0) {

        let contactDiv = $('#contactDiv');
        let copyPersonalDataRow: JQuery<HTMLElement> = $("#copyPersonalDataRow");

        let type: string = contactType.val().toString();

        if (type == "HagyomanyosPostai") {
            contactDiv.append(postAddressDiv);
            $(postAddressDiv).show();
            copyPersonalDataRow.show();

            AutoComplete.InitAutocompletes();
        }
        else {
            $postAddressDiv.detach();
            copyPersonalDataRow.hide();
        }
    }

}

jQuery(() => {
    $(document).on('change', '[id$=\'ContactType\']', () => ToggleContactTypeFields($('[id$=\'ContactType\']')));

    $(document).on('change', 'input.country-name', (event) => {
        // Előbb várjuk meg az ajax kérést az új ország id-val és névvel, utána állítjuk csak be az irányítószám mező max hosszát, külföldi település mező láthatóságát.
        $.when(
            $.ajax({
                method: 'GET',
                url: window.ETDR_RD.appConfig["UrlAction.AutoOrszag"],
                data: { term: $(event.target).val() },
                success: (data) => {
                    if (data && data.length === 1) {
                        $(event.target).parent().siblings('.country-id').attr('value', data[0].id);
                        $(event.target).attr('value', data[0].name)
                    }
                }

            })
        ).done(() => { OnCountryChanged(event); });
    });

    InitSettlementInputRow();

    $('input.settlement-name').attr("readonly", "readonly");
});
